import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=47fb964d"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"
import style0 from "./Cart.vue?vue&type=style&index=0&id=47fb964d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports